import React from 'react';

const LocationSection = ({ displayData, localFormData, setLocalFormData, openMap, clearTableData }) => {
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Местоположение</h4>
        <button 
          type="button" 
          onClick={() => clearTableData('location')}
          style={{
            background: '#6c757d',
            color: 'white',
            border: 'none',
            padding: '5px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          Очистить
        </button>
      </div>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>Широта <span className="required">*</span></th>
              <th>Долгота <span className="required">*</span></th>
              <th>Высота над уровнем моря</th>
            </tr>
          </thead>
          <tbody>
            <tr>
             <td className="coordinate-cell">
               <input
                 type="text"
                 name="lat"
                 id="form1-lat"
                 value={displayData.lat ? (displayData.lat.lat ? parseFloat(displayData.lat.lat).toFixed(6) : '') : ''}
                 readOnly
                 className={`form-control ${(!displayData.lat || !displayData.lat.lat) ? 'required-field' : ''} coordinate-field`}
                 placeholder="Нажмите для выбора координат"
                 onClick={openMap}
                 style={{ cursor: 'pointer' }}
               />
             </td>
             <td className="coordinate-cell">
               <input
                 type="text"
                 name="lon"
                 id="form1-lon"
                 value={displayData.lon ? (displayData.lon.lng ? parseFloat(displayData.lon.lng).toFixed(6) : '') : ''}
                 readOnly
                 className={`form-control ${(!displayData.lon || !displayData.lon.lng) ? 'required-field' : ''} coordinate-field`}
                 placeholder="Нажмите для выбора координат"
                 onClick={openMap}
                 style={{ cursor: 'pointer' }}
               />
             </td>
              <td className="coordinate-cell">
                <input
                  type="number"
                  name="vnum"
                  id="form1-vnum"
                  value={displayData.vnum || ''}
                  onChange={(e) => {
                    // Разрешаем только целые числа
                    const value = e.target.value;
                    if (value === '' || /^\d+$/.test(value)) {
                      const newData = { ...localFormData, vnum: value };
                      setLocalFormData(newData);
                      if (setLocalFormData) {
                        setLocalFormData(prev => ({ ...prev, vnum: value }));
                      }
                    }
                  }}
                  className={`form-control ${!displayData.vnum ? 'required-field' : ''} coordinate-field`}
                  placeholder="м"
                  min="0"
                  step="1"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LocationSection;

